(function () {
  if (window.EvryFpg) return;

  var fpgRoots = new Set();
  var globalListenersBound = false;

  function ensureGlobalFpgListeners() {
    if (globalListenersBound) return;
    globalListenersBound = true;

    document.addEventListener('click', function (event) {
      fpgRoots.forEach(function (root) {
        if (!fpgGetOpenVariantPanel(root)) return;
        if (root.contains(event.target)) return;
        fpgCloseAllVariantPanels(root);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      fpgRoots.forEach(function (root) {
        if (!fpgGetOpenVariantPanel(root)) return;
        fpgCloseAllVariantPanels(root);
      });
    });
  }

  function fpgActivateSwatch(swatchBtn, event) {
    if (!swatchBtn) return;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    fpgHandleSwatchClick(swatchBtn);
  }

  function initFpgSwatches(root) {
    if (!root || root.dataset.fpgSwatchesDelegated === 'true') return;
    root.dataset.fpgSwatchesDelegated = 'true';

    var swatchPointer = { x: 0, y: 0, btn: null };

    root.addEventListener(
      'pointerdown',
      function (event) {
        var swatchBtn = event.target.closest('[data-fpg-swatch]');
        if (!swatchBtn) {
          swatchPointer.btn = null;
          return;
        }

        event.stopPropagation();
        swatchPointer.btn = swatchBtn;
        swatchPointer.x = event.clientX;
        swatchPointer.y = event.clientY;
      },
      true
    );

    root.addEventListener(
      'pointerup',
      function (event) {
        var swatchBtn = event.target.closest('[data-fpg-swatch]');
        if (!swatchBtn || swatchPointer.btn !== swatchBtn) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        var dx = Math.abs(event.clientX - swatchPointer.x);
        var dy = Math.abs(event.clientY - swatchPointer.y);
        swatchPointer.btn = null;

        if (dx > 15 || dy > 15) return;

        fpgActivateSwatch(swatchBtn, event);
      },
      true
    );

    root.addEventListener(
      'click',
      function (event) {
        var swatchBtn = event.target.closest('[data-fpg-swatch]');
        if (!swatchBtn) return;

        if (
          event.pointerType === 'touch' ||
          (event.sourceCapabilities && event.sourceCapabilities.firesTouchEvents)
        ) {
          return;
        }

        fpgActivateSwatch(swatchBtn, event);
      },
      true
    );
  }

  function fpgHandleSwatchClick(swatchBtn) {
    var imageUrl = swatchBtn.dataset.imageUrl;
    if (!imageUrl) return;

    if (swatchBtn.classList.contains('fpg__swatch--active')) return;

    var card = swatchBtn.closest('[data-fpg-card]');
    if (!card) return;

    var primaryImage = card.querySelector('.fpg__image--primary');
    if (!primaryImage) return;

    var imageSrcset = swatchBtn.dataset.imageSrcset;

    card.querySelectorAll('[data-fpg-swatch]').forEach(function (btn) {
      btn.classList.remove('fpg__swatch--active');
    });
    swatchBtn.classList.add('fpg__swatch--active');

    function applyImage() {
      if (imageSrcset) {
        primaryImage.srcset = imageSrcset;
      } else {
        primaryImage.removeAttribute('srcset');
      }

      primaryImage.src = imageUrl;
      primaryImage.removeAttribute('loading');
    }

    if (window.EvryVariantBlink && window.EvryVariantBlink.swap) {
      window.EvryVariantBlink.swap({
        container: card.querySelector('.fpg__media'),
        imageUrl: imageUrl,
        applyImage: applyImage,
      });
      return;
    }

    applyImage();
  }

  function fpgOpenCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component, cart-drawer');
    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      drawer.open();
    } else if (typeof drawer.show === 'function') {
      drawer.show();
    } else {
      drawer.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
    }
  }

  function fpgUpdateCartBubbles(itemCount) {
    document
      .querySelectorAll('[data-testid="cart-bubble"], [ref="cartBubbleCount"]')
      .forEach(function (el) {
        el.textContent = itemCount;
      });

    document.querySelectorAll('.cart-bubble .visually-hidden').forEach(function (hidden) {
      hidden.textContent = 'Total items in cart: ' + itemCount;
    });

    document.querySelectorAll('cart-items-component [ref="cartItemCount"]').forEach(function (el) {
      el.textContent = itemCount;
    });
  }

  async function fpgRefreshCartSections() {
    var components = document.querySelectorAll('cart-items-component[data-section-id]');
    if (!components.length) return;

    var sectionIds = Array.from(
      new Set(
        Array.from(components).map(function (component) {
          return component.dataset.sectionId;
        })
      )
    );

    try {
      var response = await fetch(window.location.pathname + '?sections=' + sectionIds.join(','));
      var sections = await response.json();

      sectionIds.forEach(function (sectionId) {
        var htmlString = sections[sectionId];
        if (!htmlString) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(htmlString, 'text/html');
        var newComponent =
          doc.querySelector('cart-items-component[data-section-id="' + sectionId + '"]') ||
          doc.querySelector('cart-items-component');

        if (!newComponent) return;

        document
          .querySelectorAll('cart-items-component[data-section-id="' + sectionId + '"]')
          .forEach(function (current) {
            current.innerHTML = newComponent.innerHTML;
          });
      });
    } catch (error) {
      console.error('Error refreshing cart sections:', error);
    }
  }

  async function fpgUpdateCartUI() {
    try {
      var response = await fetch('/cart.js?timestamp=' + Date.now());
      var cart = await response.json();
      fpgUpdateCartBubbles(cart.item_count);
      await fpgRefreshCartSections();
      return cart;
    } catch (error) {
      console.error('Error updating cart UI:', error);
    }
  }

  function fpgTriggerCartUpdates() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function fpgGetAtcButton(card, contextButton) {
    if (!card) return null;

    if (contextButton && contextButton.closest('[data-fpg-atc-desktop]')) {
      return contextButton
        .closest('[data-fpg-atc-desktop]')
        .querySelector('[data-fpg-open-variants], [data-fpg-add-variant]');
    }

    var atc = card.querySelector('[data-fpg-atc]');
    if (!atc) return null;
    return atc.querySelector('[data-fpg-open-variants], [data-fpg-add-variant]');
  }

  function fpgIsDesktopAtcButton(button) {
    return !!(button && button.classList.contains('fpg__atc-desktop-btn'));
  }

  function fpgSetButtonLoading(button, isLoading) {
    if (!button) return;

    var isDesktopBtn = fpgIsDesktopAtcButton(button);
    var loadingClass = isDesktopBtn ? 'fpg__atc-desktop-btn--loading' : 'fpg__atc-btn--loading';
    var spinner = button.querySelector(
      isDesktopBtn ? '.fpg__atc-desktop-spinner' : '.fpg__atc-btn-spinner'
    );

    if (isLoading) {
      button.classList.add(loadingClass);
      button.disabled = true;
      if (spinner) {
        spinner.hidden = false;
      }
      return;
    }

    button.classList.remove(loadingClass);
    button.disabled = false;
    if (spinner) {
      spinner.hidden = true;
    }
  }

  function fpgGetMobileMediaStack(panel) {
    if (!panel || panel.closest('[data-fpg-atc-desktop]')) return null;
    return panel.closest('.fpg__media-stack');
  }

  function fpgSyncMobileVariantPanel(panel) {
    var mediaStack = fpgGetMobileMediaStack(panel);
    if (!mediaStack) return;

    var media = mediaStack.querySelector('.fpg__media');
    var atc = mediaStack.querySelector('.fpg__atc');
    var inset = 1;
    var atcHeight = atc ? atc.offsetHeight : 42;
    var mediaHeight = media ? media.offsetHeight : mediaStack.offsetHeight - atcHeight - 1;
    var maxHeight = mediaHeight - inset;

    panel.style.setProperty('--fpg-variant-bottom-offset', atcHeight + 'px');
    panel.style.setProperty('--fpg-variant-max-height', Math.max(0, maxHeight) + 'px');
    panel.style.removeProperty('height');
  }

  function fpgClearMobileVariantPanel(panel) {
    if (!panel) return;

    panel.style.removeProperty('--fpg-variant-bottom-offset');
    panel.style.removeProperty('--fpg-variant-max-height');
    panel.style.removeProperty('height');

    var mediaStack = fpgGetMobileMediaStack(panel);
    if (mediaStack) {
      mediaStack.classList.remove('fpg__media-stack--variants-open');
    }
  }

  function fpgCloseVariantPanel(panel) {
    if (!panel || !panel.classList.contains('quick-variant-menu--open')) return;

    panel.classList.remove('quick-variant-menu--open');
    panel.setAttribute('aria-hidden', 'true');
    fpgClearMobileVariantPanel(panel);

    var desktopWrap = panel.closest('[data-fpg-atc-desktop]');
    if (desktopWrap) {
      desktopWrap.classList.remove('fpg__atc-desktop--menu-open');
    }

    var dropup = panel.closest('[data-fpg-atc-dropup]');
    if (dropup) {
      var openBtn = dropup.querySelector('[data-fpg-open-variants]');
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'false');
      }
    }
  }

  function fpgCloseAllVariantPanels(root, exceptPanel) {
    if (!root) return;

    root.querySelectorAll('[data-fpg-variant-panel]').forEach(function (panel) {
      if (exceptPanel && panel === exceptPanel) return;
      fpgCloseVariantPanel(panel);
    });
  }

  function fpgOpenVariantPanel(panel) {
    if (!panel) return;

    panel.setAttribute('aria-hidden', 'false');

    var mediaStack = fpgGetMobileMediaStack(panel);
    if (mediaStack) {
      mediaStack.classList.add('fpg__media-stack--variants-open');
      fpgSyncMobileVariantPanel(panel);
    }

    var desktopWrap = panel.closest('[data-fpg-atc-desktop]');
    if (desktopWrap) {
      desktopWrap.classList.add('fpg__atc-desktop--menu-open');
    }

    var dropup = panel.closest('[data-fpg-atc-dropup]');
    if (dropup) {
      var openBtn = dropup.querySelector('[data-fpg-open-variants]');
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'true');
      }
    }

    requestAnimationFrame(function () {
      panel.classList.add('quick-variant-menu--open');
      fpgSyncMobileVariantPanel(panel);
    });
  }

  function fpgGetOpenVariantPanel(root) {
    return root ? root.querySelector('[data-fpg-variant-panel].quick-variant-menu--open') : null;
  }

  function fpgWaitForNextPaint() {
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(resolve);
      });
    });
  }

  function fpgShowAtcError(card, message) {
    if (!card) return;

    var errorEl = card.querySelector('.fpg__atc-error');
    if (!errorEl) return;

    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function fpgClearAtcError(card) {
    if (!card) return;

    var errorEl = card.querySelector('.fpg__atc-error');
    if (!errorEl) return;

    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  async function fpgAddToCart(variantId, atcButton, root, card) {
    if (!atcButton) return;

    var loadingClass = fpgIsDesktopAtcButton(atcButton)
      ? 'fpg__atc-desktop-btn--loading'
      : 'fpg__atc-btn--loading';
    if (atcButton.classList.contains(loadingClass)) return;

    fpgClearAtcError(card);
    fpgSetButtonLoading(atcButton, true);

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        }),
      });

      var result = await response.json();

      if (!response.ok) {
        console.error('Shopify add to cart response:', result);
        throw new Error(result.description || result.message || 'Add to cart failed');
      }

      await fpgUpdateCartUI();
      await fpgWaitForNextPaint();
      fpgOpenCartDrawer();
      fpgTriggerCartUpdates();
    } catch (error) {
      console.error('Error adding to cart:', error);
      fpgShowAtcError(card, error.message || 'Could not add to cart. Please try again.');
    } finally {
      fpgSetButtonLoading(atcButton, false);
    }
  }

  function initFpgAtc(root) {
    if (!root || root.dataset.fpgAtcDelegated === 'true') return;
    root.dataset.fpgAtcDelegated = 'true';
    fpgRoots.add(root);
    ensureGlobalFpgListeners();

    root.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-fpg-open-variants]');
      if (openBtn) {
        event.preventDefault();
        event.stopPropagation();

        var openCard = openBtn.closest('[data-fpg-card]');
        var dropup = openBtn.closest('[data-fpg-atc-dropup]');
        var panel = dropup
          ? dropup.querySelector('[data-fpg-variant-panel]')
          : openCard && openCard.querySelector('.fpg__media-stack > [data-fpg-variant-panel]');
        if (!panel) return;

        if (panel.classList.contains('quick-variant-menu--open')) {
          fpgCloseVariantPanel(panel);
          return;
        }

        fpgCloseAllVariantPanels(root, panel);
        fpgOpenVariantPanel(panel);
        return;
      }

      var variantBtn = event.target.closest('[data-fpg-variant-panel] [data-fpg-add-variant]');
      if (variantBtn) {
        event.preventDefault();
        event.stopPropagation();
        if (variantBtn.disabled) return;

        var variantCard = variantBtn.closest('[data-fpg-card]');
        var variantPanel = variantBtn.closest('[data-fpg-variant-panel]');
        var variantAtcButton = fpgGetAtcButton(variantCard, variantBtn);

        fpgCloseVariantPanel(variantPanel);
        fpgAddToCart(variantBtn.dataset.variantId, variantAtcButton, root, variantCard);
        return;
      }

      var singleBtn = event.target.closest('[data-fpg-add-variant]');
      if (singleBtn) {
        event.preventDefault();
        event.stopPropagation();

        var singleLoadingClass = fpgIsDesktopAtcButton(singleBtn)
          ? 'fpg__atc-desktop-btn--loading'
          : 'fpg__atc-btn--loading';
        if (singleBtn.disabled || singleBtn.classList.contains(singleLoadingClass)) return;

        var singleCard = singleBtn.closest('[data-fpg-card]');
        fpgCloseAllVariantPanels(root);
        fpgAddToCart(singleBtn.dataset.variantId, singleBtn, root, singleCard);
        return;
      }

      var openPanel = fpgGetOpenVariantPanel(root);
      if (!openPanel) return;

      var activeCard = openPanel.closest('[data-fpg-card]');
      if (activeCard && !activeCard.contains(event.target)) {
        fpgCloseAllVariantPanels(root);
      }
    });
  }

  function initRoot(root) {
    if (!root) return;

    var cards = root.querySelectorAll('[data-fpg-card]');
    if (!cards.length) return;

    initFpgAtc(root);
    initFpgSwatches(root);
  }

  function initAllNowTrendingGrids() {
    document.querySelectorAll('.now-trending-grid').forEach(initRoot);
  }

  function initAllFpgRoots() {
    initAllNowTrendingGrids();
  }

  window.EvryFpg = {
    initRoot: initRoot,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFpgRoots);
  } else {
    initAllFpgRoots();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;

    if (target.matches('.now-trending-grid') || target.querySelector('.now-trending-grid')) {
      initAllNowTrendingGrids();
    }

    if (window.EvryNowTrendingSlider && window.EvryNowTrendingSlider.refresh) {
      window.EvryNowTrendingSlider.refresh(target);
    }
  });
})();
